import { ScrollView } from "components";
import SectionHeader from "./SectionHeader";
import { Layout } from "antd";

const PanelContent = ({ children }) => {
    return (
        <ScrollView style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            overflow: "auto",
            padding: "16px",
        }}>
            {children}
        </ScrollView>
    );
};


const BuilderPanel = ({
    preview,
    rightPanel,
    leftPanel
}) => {
    return (
        <div style={{
            height: "calc(100vh - 232px)",
            display: "flex",
            flexDirection: "column"
        }}>
            <div style={{
                height: "150px",
                padding: "4px",
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
            }}>
                <ScrollView style={{ height: "100%" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "6px", paddingInline: "8px" }}>
                        {preview}
                    </div>
                </ScrollView>
            </div>

            <div style={{
                flex: 1,
                display: "flex",
                overflow: "hidden"
            }}>
                <Layout style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    background: '#131313',
                    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
                }}>
                    <SectionHeader label={leftPanel?.label} />
                    <PanelContent>
                        {leftPanel?.content}
                    </PanelContent>
                </Layout>

                <Layout style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    background: '#131313',
                }}>
                    <SectionHeader label={rightPanel?.label} />
                    <PanelContent>
                        {rightPanel?.content}
                    </PanelContent>
                </Layout>
            </div>
        </div>
    );
};

export default BuilderPanel;

